<template>
	<div>
        <div class="home-v-img">
            <div class="container">
              <div class="row section-separator">
                <div class="col-sm-12 section-title wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.2s; animation-name: none;">
                  <h3>Client Reviews</h3>
                </div>
                <div class="col-sm-12 wow fadeInUp owl-carousel owl-theme owl-responsive-1170 owl-loaded" id="mh-client-review" data-wow-duration="0.8s" data-wow-delay="0.3s" style="visibility: hidden; animation-duration: 0.8s; animation-delay: 0.3s; animation-name: none;">
    
                  <div class="owl-stage-outer">
                    <div class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all 0s ease 0s; width: 2220px;">
                      <div class="owl-item active" style="width: 370px; margin-right: 0px;">
                        <div class="each-client-item">
                          <div class="mh-client-item dark-bg black-shadow-1">
                            <img src="/static/images/c-1.png" alt="" class="img-fluid">
                            <p>Absolute wonderful ! I am completely
                              blown away.The very best.I was amazed
                              at the quality</p>
                            <h4>John Mike</h4>
                            <span>CEO, Author.Inc</span>
                          </div>
                        </div>
                      </div>
                      <div class="owl-item active" style="width: 370px; margin-right: 0px;">
                        <div class="each-client-item">
                          <div class="mh-client-item dark-bg black-shadow-1">
                            <img src="/static/images/c-1.png" alt="" class="img-fluid">
                            <p>Absolute wonderful ! I am completely
                              blown away.The very best.I was amazed
                              at the quality</p>
                            <h4>John Mike</h4>
                            <span>CEO, Author.Inc</span>
                          </div>
                        </div>
                      </div>
                      <div class="owl-item active" style="width: 370px; margin-right: 0px;">
                        <div class="each-client-item">
                          <div class="mh-client-item dark-bg black-shadow-1">
                            <img src="/static/images/c-1.png" alt="" class="img-fluid">
                            <p>Absolute wonderful ! I am completely
                              blown away.The very best.I was amazed
                              at the quality</p>
                            <h4>John Mike</h4>
                            <span>CEO, Author.Inc</span>
                          </div>
                        </div>
                      </div>
                      <div class="owl-item" style="width: 370px; margin-right: 0px;">
                        <div class="each-client-item">
                          <div class="mh-client-item dark-bg black-shadow-1">
                            <img src="/static/images/c-1.png" alt="" class="img-fluid">
                            <p>Absolute wonderful ! I am completely
                              blown away.The very best.I was amazed
                              at the quality</p>
                            <h4>John Mike</h4>
                            <span>CEO, Author.Inc</span>
                          </div>
                        </div>
                      </div>
                      <div class="owl-item" style="width: 370px; margin-right: 0px;">
                        <div class="each-client-item">
                          <div class="mh-client-item dark-bg black-shadow-1">
                            <img src="/static/images/c-1.png" alt="" class="img-fluid">
                            <p>Absolute wonderful ! I am completely
                              blown away.The very best.I was amazed
                              at the quality</p>
                            <h4>John Mike</h4>
                            <span>CEO, Author.Inc</span>
                          </div>
                        </div>
                      </div>
                      <div class="owl-item" style="width: 370px; margin-right: 0px;">
                        <div class="each-client-item">
                          <div class="mh-client-item dark-bg black-shadow-1">
                            <img src="/static/images/c-1.png" alt="" class="img-fluid">
                            <p>Absolute wonderful ! I am completely
                              blown away.The very best.I was amazed
                              at the quality</p>
                            <h4>John Mike</h4>
                            <span>CEO, Author.Inc</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="owl-controls">
                    <div class="owl-nav">
                      <div class="owl-prev" style="">prev</div>
                      <div class="owl-next" style="">next</div>
                    </div>
                    <div class="owl-dots" style="">
                      <div class="owl-dot active"><span></span></div>
                      <div class="owl-dot"><span></span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
	</div>
</template>
<script>
export default {
    data(){
        return {

        }
    },
    components: {  },
    created(){

    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {

    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Testimonial.vue